"use strict";

(function (global) {
  /**
   * Функции отвечающие за работу с заданиями.
   * @namespace Core.jobs
   * @since 5.3.0.1010
   */
  global.jobs = {};
})(window.Core);

(function (global) {
  /**
   * Изменяет статус прочитанности заданий.
   * @description Задания помечаются непрочитанными, если все выбранные задания прочитаны. Иначе, все задания помечаются прочитанными.
   * @param {List} items Список элменетов, статус прочитанности которых требуется изменить.
   */
  global.toggleReadStatus = function (items) {
    var jobs = _.filter(items, function (e) { return e.type === OBJECT_TYPE.JOB });
    var jobIds = _.map(jobs, function (e) { return e.id });
    var unreadJobs = _.filter(jobs, function (job) { return job.isUnread(); });
    var markAsRead = unreadJobs.length > 0;

    WA.SRV.call('/Job.asmx/MassMarkAsRead', { JobIDList: jobIds, MarkAsRead: markAsRead }).success(function (res) {
      var count = -unreadJobs.length;
      // Shirobokov_AV: Задания помечаются непрочитанными, если все выбранные задания прочитаны. Иначе, все задания помечаются прочитанными.
      if (!markAsRead) {
        count = jobs.length;
      }

      $.each(jobs, function (i, job) {
        if (markAsRead) {
          job.removeUnreadStyle();
        } else {
          job.addUnreadStyle();
        }
      });

      ChangeUnreadCountInTree(count);
    }).error(function (res) {
      (new WA.CMP.dialogs.MessageBox()).showError(res);
    });
  };
  
  /**
   * Сохраняет карточку задания.  
   * @param {boolean} needClose TRUE если карточка должна быть закрыта, иначе - FALSE.
   * @since 5.7.0
   */
  global.SaveInBaseJob = function (needClose) {    
    const activeText = $('textarea#CardControl_EditedText').val();
    const url = (new WA.URL());
    WA.SRV.request('/Job.asmx/Save', {
      ActiveText: activeText,
      FolderId: url.getParam('opener') || -1,
      JobID: WA.CR.ID,            
    }).done(newModel => {
      let model = JSON.parse(newModel);
      WA.CR.CardTab.updateModel(model.cardTabModel);
      if (needClose) {
        WA.CR.window.unbind('beforeClose');        
        WA.CR.window.close();        
      }
    }).fail(errorMessage => {
      WA.CR.inlineHint.showError(errorMessage);
    });
  };
  
  /**
   * Выполняет задание с переданным результатом.
   *
   * @function Core.jobs.performJob
   * @param {number} jobID ИД задания.
   * @param {number} performResult Индекс варианта выполнения задания.
   * @param {boolean} [needClose = true] TRUE если карточка должна быть закрыта, иначе - FALSE.
   * @return {Deferred<void>}
   * @since 5.7.0
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.performJob = (jobID, performResult, needClose = true) => {
    const d = $.Deferred();
    let serviceURl = '/Job.asmx/PerformJob';
    let params = {     
      JobID: jobID,      
      PerformResult: performResult || 0,
    }; 
    // Если это текущее открытое задание, то получаем текст задания и его тоже передаем в веб-метод для сохранения.
    if (jobID === WA.CR.ID) {
      const activeText = $('textarea#CardControl_EditedText').val();
      params = Object.assign(params, {
        ActiveText: activeText || '',
      });      
      serviceURl = '/Job.asmx/PerformJobWithTextUpdating';
    }    
    WA.SRV.request(serviceURl, params).done(() => {
      if (needClose) {
        if (opener && opener.WA.getLocation() === 'explorer' && opener.WA.CR.objectList) {
          opener.WA.CR.objectList.reload();
        }
        // После выполнения задания нужно снять с него блокировку
        WA.SRV.request('Job.asmx/FreeJob', { JobID: jobID }).always(() => {
          WA.CR.window.unbind('beforeClose');
          WA.CR.window.close();                    
        });        
      }
      d.resolve();
    }).fail(errorMessage => {
      WA.CR.inlineHint.showError(errorMessage);
      d.reject(errorMessage);
    });
    return d.promise();
  }

})(window.Core.jobs)
